/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { buildBreadcrumbJsonLd, BreadcrumbJsonLdOptions } from "./breadcrumb";

/**
 * Emits `BreadcrumbList` schema.org JSON-LD for the current page's position in
 * the site hierarchy, for breadcrumb rich results
 * (https://developers.google.com/search/docs/appearance/structured-data/breadcrumb).
 *
 * The trail is derived from the URL path only, never page body content. Renders
 * nothing for non-nested slugs (fewer than two path segments), so it is safe to
 * drop into any page template unconditionally.
 */
export const CosmosBreadcrumbJsonLd = (props: BreadcrumbJsonLdOptions): React.JSX.Element | null => {
	const json = buildBreadcrumbJsonLd(props);

	if (!json) {
		return null;
	}

	return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: json }} />;
};
